import { axios } from "../lib/axios";

export const getModeOfPayment = async function (modeOfPaymentId) {
  try {
    const response = await axios.get("settings/getmodeofpayment", {
      params: { modeOfPaymentId: modeOfPaymentId },
    });
    return response.data.data;
  } catch (error) {
    return error.response;
  }
};

export const getAllModeOfPayments = async function () {
  try {
    const response = await axios.get("settings/getallmodeofpayments");
    console.log(response);
    return response.data.data;
  } catch (error) {
    return error.response;
  }
};

export const addModeOfPayment = async function (model) {
  try {
    const response = await axios.post("settings/addmodeofpayment", model, {
      header: { "Content-Type": "application/json" },
    });
    return response;
  } catch (error) {
    return error.response;
  }
};

export const updateModeOfPayment = async function (model) {
  try {
    const response = await axios.post("settings/updatemodeofpayment", model, {
      header: { "Content-Type": "application/json" },
    });
    return response;
  } catch (error) {
    return error.response;
  }
};

export const deleteModeOfPayment = async function (model) {
  try {
    const response = await axios.delete("settings/deletemodeofpayment", {
      data: model,
      header: { "Content-Type": "application/json" },
    });
    return response;
  } catch (error) {
    return error.response;
  }
};
